/**
 * random.js
 */


function randomStringChars(length, chars) {
  var result = '';
  for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}


// http://stackoverflow.com/questions/962802#962890
function shuffle(array) {
  var tmp, current, top = array.length;
  if(top) while(--top) {
    current = Math.floor(Math.random() * (top + 1));
    tmp = array[current];
    array[current] = array[top];
    array[top] = tmp;
  }
  return array;
}


export function randomString(length) {
  return randomStringChars(
    length,
    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  );
}


export function randomAlphaString(length) {
  return randomStringChars(
    length,
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  );
}


export function randomIntArray(min, max, length) {
  for (var a=[], i=min; i<=max; ++i) a.push(i);
  a = shuffle(a);
  return a.slice(0, length);
}


export function randomArraySubset(array, minItems = 3) {
  array = shuffle(array);
  minItems = Math.min(array.length, minItems);
  return array.slice(1, minItems + 1);
}


export function randomValueFromArray(array) {
  return shuffle(array)[0];
}


// random integer, max & min included
export function randomInt(min = 1, max = 10) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}